export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "inspects_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista tipos de inspecciones"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir"])},
          "quality_inspects_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de calidad"])},
          "total_number_inspects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones"])}
        }
      },
      "en": {
        "labels": {
          "inspects_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspects"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to templates"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New"])},
          "quality_inspects_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspections"])},
          "total_number_inspects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspections"])}
        }
      }
    }
  })
}